import { useSelector } from 'react-redux';

import State from 'types/State';
import { getIsSignedIn } from 'redux-implementations/selectors';

export function useIsSignedIn(): boolean {
  return useSelector((state: State) => getIsSignedIn(state));
}
